import React, { useEffect } from 'react';
import { SmartHelpProps } from '../Smarts/SmartHelp';
import { TitleContext } from '../../providers/TitleProvider/TitleProvider';
import { useTopBarStore } from './TopBarStore';

export type ProductType = 'audience' | 'programmatic' | 'full' | 'admin';

export type TopBarContextProps = {
	title?: string;
	children?: React.ReactNode | null;
	productType?: ProductType;
	smartHelp?: SmartHelpProps;
	openHelp?: () => void;
};

// Hook to integrate with TitleProvider
export function useTopBarTitleIntegration() {
	const { title } = useTopBarStore();
	const { setTitle } = React.useContext(TitleContext);

	useEffect(() => {
		if (title) {
			setTitle(title);
		}
	}, [title, setTitle]);
}

export function TopBarProvider({ children }: { children: React.ReactNode }) {
	// Integrate with TitleProvider
	useTopBarTitleIntegration();

	return <>{children}</>;
}
